import type { ReactNode } from 'react'

interface AppUser {
  nombre_completo: string
}

interface AppHeaderProps {
  title: string
  user?: AppUser | null
  onLogout?: () => void
  children?: ReactNode
  titleSize?: 'normal' | 'large'
}

// Header compartido Hospital-Tech: degradado marino->navy con el logo
// blanco oficial. Las pantallas rediseñadas a fondo llevan su propio
// header; este cubre el resto con la misma identidad.
export default function AppHeader({
  title,
  user,
  onLogout,
  children,
  titleSize = 'normal',
}: AppHeaderProps) {
  return (
    <header
      className="sticky top-0 z-30 px-4 md:px-6 py-3 flex items-center gap-3 text-white"
      style={{
        background: 'linear-gradient(120deg,#143C78,#1E1E3C)',
        borderBottom: '1px solid rgba(140,170,230,.18)',
      }}
    >
      <img
        src="/avante-logo-white.png"
        alt="Avante"
        style={{ height: 30 }}
        onError={(e) => ((e.target as HTMLImageElement).style.display = 'none')}
      />
      <div className="flex-1 min-w-0">
        <h1
          className={`font-bold leading-tight truncate ${titleSize === 'large' ? 'text-xl' : 'text-base md:text-lg'}`}
          style={{ fontFamily: 'Space Grotesk' }}
        >
          {title}
        </h1>
        {user?.nombre_completo && (
          <p className="text-xs truncate" style={{ color: '#94A0CD' }}>
            {user.nombre_completo}
          </p>
        )}
      </div>
      <div className="flex items-center shrink-0">
        {children}
        {onLogout && (
          <button
            onClick={onLogout}
            className="text-sm ml-3 hover:text-white"
            style={{ color: '#94A0CD' }}
          >
            Salir
          </button>
        )}
      </div>
    </header>
  )
}
